import styled from 'styled-components'
import { Scroller } from '@ta-interaktiv/react-scroller'
import {
  ContentWidth,
  TextWidth,
  TextWidthExtended,
} from '@ta-interaktiv/react-disco-grid'
import { AnnotatedImage } from './AnnotatedImage'
import { ReactNode } from 'react'

const FullWidth = styled.div``

const Cols = {
  TextWidthExtended: TextWidthExtended,
  TextWidth: TextWidth,
  ContentWidth: ContentWidth,
  FullWidth: FullWidth,
}

export const AnnotatedScroller = ({
  columnType,
  height = 300,
  data,
}: {
  columnType: 'TextWidthExtended' | 'TextWidth' | 'ContentWidth' | 'FullWidth'
  height?: number
  data: {
    frontElements: ReactNode[]
    images: {
      id: string
      src: string
      title: string
    }[]
    annotations: {
      [key: string]: Annotation[]
    }
  }
}) => {
  let Column = Cols[columnType]

  return (
    <AnnotatedScrollerRoot maxHeight={height}>
      <Column>
        <Scroller
          front={data.frontElements}
          back={(index: number, id: string) => {
            return (
              <CenterImage maxHeight={height}>
                {data.images.map((image, i) => {
                  return (
                    <AnnotatedImage
                      title={image.title}
                      key={image.id}
                      img={image.src}
                      show={image.id === id || index > data.images.length - 1}
                      annotations={data.annotations[image.id]}
                      solo={false}
                    />
                  )
                })}
              </CenterImage>
            )
          }}
        />
      </Column>
    </AnnotatedScrollerRoot>
  )
}

export const FrontElement = styled.div.attrs({ className: 'FrontElement' })<{
  distanceTop?: number
  distanceBottom?: number
}>`
  background-color: var(--front-element-bg);
  padding: 15px;
  margin-left: auto;
  margin-right: auto;
  max-width: 500px;
  -webkit-box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1);
`
const AnnotatedScrollerRoot = styled.div<{ maxHeight: number }>`

  .Scroller {
    margin-bottom: ${(props) => props.maxHeight}px;
  }
  .back {
    display: inline-block;
    height: 100%;
    width: 100%;
  }
`

const CenterImage = styled.div.attrs({ className: 'CenterImage' })<{
  maxHeight: number
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: ${(props) => props.maxHeight}px;
  width: 100%;
`
